import {
  NUMBER_KINGDOM_DISTRICTS,
  getNumberKingdomDistrict,
} from '../NumberKingdomDistrictRegistry.js';
import { getNumberKingdomState } from '../../NumberKingdomState.js';

export const RESTORED_BRIDGE_EXIT_EVENT = 'numberKingdom:restoredBridgeExitRequested';

export type RestoredBridgeExitStatus = 'locked' | 'asset-gated' | 'ready';

export interface RestoredBridgeExitResolution {
  readonly status: RestoredBridgeExitStatus;
  readonly targetDistrict: typeof NUMBER_KINGDOM_DISTRICTS.kingdomCrossroads;
  readonly route: string;
  readonly sceneKey?: string;
  readonly missingArt: readonly string[];
}

export function resolveRestoredBridgeExit(): RestoredBridgeExitResolution {
  const state = getNumberKingdomState();
  const destination = getNumberKingdomDistrict(NUMBER_KINGDOM_DISTRICTS.kingdomCrossroads);
  const missingArt = destination.artManifest
    .filter(asset => asset.required)
    .map(asset => asset.path);

  if (!state.bridgeCrossingUnlocked || state.starBridgeState !== 'restored') {
    return {
      status: 'locked',
      targetDistrict: NUMBER_KINGDOM_DISTRICTS.kingdomCrossroads,
      route: destination.route,
      missingArt,
    };
  }

  if (destination.implementation !== 'playable' || !destination.sceneKey) {
    return {
      status: 'asset-gated',
      targetDistrict: NUMBER_KINGDOM_DISTRICTS.kingdomCrossroads,
      route: destination.route,
      missingArt,
    };
  }

  return {
    status: 'ready',
    targetDistrict: NUMBER_KINGDOM_DISTRICTS.kingdomCrossroads,
    route: destination.route,
    sceneKey: destination.sceneKey,
    missingArt: [],
  };
}
